module.exports = __webpack_public_path__ + "static/media/welcome-background.647b4e6a.jpg";